import React, { FC, useState, useEffect } from 'react';
import { useRecordContext } from 'react-admin';
//import Chip from '@material-ui/core/Chip';
//import { FieldProps } from '../../types';
//import segments from '../segments/data';
//import { makeStyles } from '@material-ui/core';
import { useDataProvider } from 'react-admin';
import { useQuery } from '@tanstack/react-query';
import StatusIcon from '@mui/icons-material/CheckCircle';


import lodash from 'lodash';

interface Props {
    source?: string;
    optionValue?: string;
    optionText?: string;
    optionColor?: string;
    url: string;
    useIcon?: boolean;
    useText?: boolean;
    value?: string;
    sortable?: boolean;
    minimize?: boolean;
}

interface ResItem {
    id: any;
    item_id: any;
    item_title: any;
    item_color?: any;
}

const CustomStatusField: FC<Props> = ({ source = '', optionValue = 'item_id', optionText = 'item_title', optionColor = 'item_color', url, useIcon=true, useText=false, value = '', sortable=false, minimize=false }) => {

    const record = useRecordContext();
    let params = '';
    params = '';
    const dataProvider = useDataProvider();
    
    const { data,error,isPending,refetch } = useQuery({
        queryKey: [url, 'getAny', params], 
        queryFn: () => dataProvider.getAny(url, params)
    });

    if (!data) return null;

    const customChoices = data.data;

    if (!customChoices) return null;

    let val = 0;
    if (value.toString().length > 0)
        val = parseInt(value);
    else
        val = lodash.get(record, source);

    let color = null;
    color = customChoices.filter(cc => {return cc[optionValue] == val;})[0][optionColor] ? customChoices.filter(cc => {return cc[optionValue] == val;})[0][optionColor] : null;

    let style = {
        width: minimize ? '0.7em' : 'auto',
        marginRight: minimize ? '0.2em' : 'inherit',
        color: color ? color : 'inherit',
    };

    return useIcon ? (<StatusIcon style={style} />) : (<span>{customChoices.filter(cc => {return cc[optionValue] == val;})[0][optionText]}</span>);
};

export default CustomStatusField;
